import { useLanguage } from './LanguageProvider.jsx';
export default function Brand({ compact=false }) {
  const { t } = useLanguage();
  return <div className={`brand ${compact?'brand--compact':''}`}>
    <span className="brand__mark"><img src="/bait-henna-logo.jpg" alt={t("brand.logo")} /></span>
    <span><strong>{t("brand.name")}</strong>{compact ? null : <small>{t("brand.tagline")}</small>}</span>
  </div>;
}
